/** Estados comerciales oficiales del ecosistema Javiland */
export const COMMERCIAL_STATES = [
  { id: 'exploracion', label: 'Exploración', color: '#607d8b' },
  { id: 'propuesta_enviada', label: 'Propuesta enviada', color: '#1565c0' },
  { id: 'en_alineacion', label: 'En alineación', color: '#ef6c00' },
  { id: 'en_ejecucion', label: 'En ejecución', color: '#2e7d32' },
  { id: 'entregado', label: 'Entregado', color: '#5d4037' },
  { id: 'en_pausa', label: 'En pausa', color: '#9e9e9e' }
];

export const stateLabel = (id) =>
  COMMERCIAL_STATES.find((s) => s.id === id)?.label || id;

export const stateColor = (id) =>
  COMMERCIAL_STATES.find((s) => s.id === id)?.color || '#666';

/** Clientes Growth Partner */
export const GROWTH_PARTNER_CLIENTS = [
  {
    id: 'strutech',
    name: 'Strutech Solutions',
    sector: 'Diseño y construcción · Bogotá',
    gpState: 'en_ejecucion',
    gpPhase: 'Fase 2 — 6 pilares + MVP comercial',
    doc: 'PLAN_MAESTRO_STRUTECH_2026.md',
    url: 'https://strutechsolutions.com/',
    notes: 'Cuota 1 COP 250k recibida. Demo jun 2026.'
  },
  {
    id: 'liliana',
    name: 'Liliana Ospina',
    sector: 'Bienestar · Conecta + GP',
    gpState: 'propuesta_enviada',
    gpPhase: 'Piloto referidos + cursos → GP',
    doc: 'PROMPT_JEFE_LILIANA_OSPINA_JAVILAND.md',
    alsoIn: 'Servicios / Bienestar',
    notes: 'M1 enviado. Call 2 pendiente. Sin contrato firmado.'
  },
  {
    id: 'omar',
    name: 'Omar Londoño',
    sector: 'Tapires / Indi Stones',
    gpState: 'propuesta_enviada',
    gpPhase: '3 vías: viajes · tienda · GP indistones.co',
    doc: 'SUBPROYECTO_OMAR_JAVILAND.md',
    notes: 'M1 Instagram enviado. Sin acuerdo firmado.'
  },
  {
    id: 'kaaba',
    name: 'Kaaba Café',
    sector: 'KAABA TRADING COLOMBIA S.A.S · Café Huila',
    gpState: 'en_pausa',
    gpPhase: 'F1 web propuesta feb-2026 (COP 750k) — no aprobada',
    doc: 'PROPUESTA_COMERCIAL_KAABA_CAFE_FEB2026.md',
    pdf: 'PROPUESTA_COMERCIAL_KAABA_CAFE_FEB2026.pdf',
    notes: 'GP web en pausa. Prioridad: café en tienda Javiland.'
  },
  {
    id: 'jdn',
    name: 'JDN Life Style',
    sector: 'Moda · camisetas USA',
    gpState: 'propuesta_enviada',
    gpPhase: 'GP digital sin respuesta; canal tienda activo',
    doc: 'PROPUESTA_COMERCIAL_JDN_LIFE_STYLE_MAYO_2026.md',
    url: 'https://www.instagram.com/jdnlifestyle2024/',
    notes: 'Interés en vender camisetas en Javiland + import USA fase 2.'
  },
  {
    id: 'nutrisetas',
    name: 'Nutrisetas',
    sector: 'Setas y hongos · Shopify/Wix',
    gpState: 'en_alineacion',
    gpPhase: 'Colaboración informal (optimización Wix)',
    doc: null,
    url: 'https://www.nutrisetas.com/',
    notes: 'Acceso Wix. Catálogo completo → tienda Javiland.'
  },
  {
    id: 'rgs',
    name: 'RGS Marketing Experience',
    sector: 'Marketing BTL',
    gpState: 'entregado',
    gpPhase: 'Rediseño web + formulario leads',
    url: 'https://rgsbtl.com/',
    notes: 'Caso portfolio.'
  },
  {
    id: 'efecto-mariposa',
    name: 'Efecto Mariposa',
    sector: 'Educación y desarrollo personal',
    gpState: 'entregado',
    gpPhase: 'Páginas de cursos + optimización',
    url: 'https://efectomariposa.life/',
    notes: 'Caso portfolio.'
  }
];

/** Canal tienda / proveedores */
export const CANAL_TIENDA_ACTORS = [
  {
    id: 'kaaba',
    name: 'Kaaba Café',
    canalState: 'en_alineacion',
    priority: 'alta',
    blocker: 'Precios y fichas de producto (seguimiento WhatsApp)',
    followUp: true,
    followUpHint: 'Pedir precios y SKUs café Huila al cliente',
    nextStep: 'Crear SKU en Productos cuando lleguen datos'
  },
  {
    id: 'himalaya',
    name: 'Himalaya (dropshipping)',
    canalState: 'en_ejecucion',
    priority: 'alta',
    blocker: null,
    doc: 'MATRIZ_PROVEEDORES_JAVILAND_2026.md',
    nextStep: 'Operación diaria cola dropshipping'
  },
  {
    id: 'annita',
    name: 'AnnitaMiel',
    canalState: 'en_alineacion',
    priority: 'media',
    blocker: 'Flete Medellín → Chía (Santiago)',
    doc: 'PROPUESTA_ANNITAMIEL_2026.md',
    nextStep: 'Reorden PET 750g tras flete'
  },
  {
    id: 'jdn',
    name: 'JDN Life Style',
    canalState: 'en_alineacion',
    priority: 'media',
    blocker: 'Lista camisetas (nombre, talla, precio, foto)',
    nextStep: 'Fase 1: SKUs actuales. Fase 2: import USA'
  },
  {
    id: 'nutrisetas',
    name: 'Nutrisetas',
    canalState: 'en_alineacion',
    priority: 'media',
    blocker: 'Alinear catálogo completo nutrisetas.com → Javiland',
    nextStep: 'Importar mismos productos a tienda'
  },
  {
    id: 'jdn-import',
    name: 'JDN import USA',
    canalState: 'exploracion',
    priority: 'baja',
    blocker: 'Inversión + marcas (Columbia, Quiksilver, etc.)',
    nextStep: 'Fase 2 tras validar camisetas actuales'
  }
];

export const GP_FILTER_OPTIONS = [
  { id: 'activos', label: 'Activos' },
  { id: 'entregados', label: 'Entregados' },
  { id: 'en_pausa', label: 'En pausa' },
  { id: 'todos', label: 'Todos' }
];

export function filterGpClients(filterId) {
  if (filterId === 'entregados') {
    return GROWTH_PARTNER_CLIENTS.filter((c) => c.gpState === 'entregado');
  }
  if (filterId === 'en_pausa') {
    return GROWTH_PARTNER_CLIENTS.filter((c) => c.gpState === 'en_pausa');
  }
  if (filterId === 'activos') {
    return GROWTH_PARTNER_CLIENTS.filter((c) =>
      ['propuesta_enviada', 'en_alineacion', 'en_ejecucion', 'exploracion'].includes(c.gpState)
    );
  }
  return GROWTH_PARTNER_CLIENTS;
}
